export interface CompanyMeta {
  id: string;
  name: string;
  slug: string;
  description?: string | null;
  website?: string | null;
  industry?: string | null;
  company_size?: string | null;
  logo_url?: string | null;
  subscription_tier?: string | null;
  subscription_active?: boolean | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  total_users?: number | null;
  total_candidates?: number | null;
  total_jobs?: number | null;
}

export interface CompanySubscription {
  id: string;
  company_id: string;
  company?: CompanyMeta[] | CompanyMeta | null;
  tier_id: string;
  tier_name: string;
  tier_type: string;
  status: string;
  billing_period: string;
  payment_method: string;
  current_period_price: string | number;
  credits_per_period: number;
  locked_price_monthly?: string | number | null;
  locked_price_yearly?: string | number | null;
  locked_credits_per_dollar?: number | null;
  locked_topup_discount?: string | number | null;
  locked_yearly_bonus?: string | number | null;
  locked_monthly_bonus?: string | number | null;
  current_credit_balance?: number | null;
  days_until_renewal: number;
  started_at?: string | null;
  trial_ends_at?: string | null;
  current_period_start?: string | null;
  current_period_end?: string | null;
  cancelled_at?: string | null;
  cancel_at_period_end?: boolean | null;
  scheduled_tier_id?: string | null;
  scheduled_tier_name?: string | null;
  scheduled_billing_period?: string | null;
  scheduled_change_at?: string | null;
  auto_renew?: boolean | null;
  created_at: string;
  updated_at: string;
  total_users?: number | null;
}

export interface CompanyListPayload {
  subscriptions: CompanySubscription[];
  total: number;
  has_more: boolean;
  total_active: number;
  total_trial: number;
  total_cancelled: number;
  total_past_due: number;
  total_expired: number;
}

export type CompanySummary = Pick<
  CompanyListPayload,
  | "total_active"
  | "total_trial"
  | "total_cancelled"
  | "total_past_due"
  | "total_expired"
>;

export interface CompanyListParams {
  limit: number;
  offset: number;
  search?: string;
  sub_status?: string;
  tier_filter?: string;
}

export interface CompanyManagementState {
  subscriptions: CompanySubscription[];
  loading: boolean;
  error: string | null;
  searchTerm: string;
  selectedStatus: string;
  selectedTier: string;
  page: number;
  pageSize: number;
  total: number;
  summary: CompanySummary;
  selectedCompany: CompanySubscription | null;
  statusChangeCompany: CompanySubscription | null;
  statusMessage: string | null;
  showDetails: boolean;
  submitting: boolean;
}

export const emptyCompanySummary: CompanySummary = {
  total_active: 0,
  total_trial: 0,
  total_cancelled: 0,
  total_past_due: 0,
  total_expired: 0,
};
